import { lazyLoad } from 'utils/loadable';

export const CreateEnvironment = lazyLoad(
  () => import('./createEnvironment.page'),
  (module) => module.CreateEnvironment
);
